import { useApolloClient } from '@apollo/client';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CHECK_ASSIGN_USER, IS_USER_ACCESS_PAGE, TITLE_BOX_ACTION } from '../../../src/config/constants';
import { executeGraphQLMutation } from '../../common/executeGraphQLQuery';
import crypto from '../../config/crypto';
import GeneralService from '../../services/generalService';
import { UPDATE_LEAD_STATUS } from '../../services/leads.gql';
import { getLoanDetail } from '../../store/action/allAction';
import Loader from '../elements/Loader';
import Modal from '../elements/Modal';
import LeadRemarkHistory from '../lead-list/LeadRemarkHistory';
import DocumentGallery from './DocumentGallery';
import VehicleDetailAndSoftCreditJson from './formFields/vehicleDetailAndSoftCredit.json';
import SoftApprovalCreditInvestigation from './soft-approval/SoftApprovalCreditInvestigation';
import { generateMutationAndVariables, getSectionInfo, isPageReadOnly, setDocPath } from './soft-approval/VehicleDetailAndSoftCredit.helper';
import VehicleTransferCreditInvestigation from './soft-approval/VehicleTransferCreditInvestigation';
import CreditAdviceReceived from './credit-advice-received/CreditAdviceReceived';

const now = new Date();
const currhour = Number(now.getHours());
const currmin = now.getMinutes();

const VehicleDetailAndSoftCredit = (props) => {
    let current_page = props.current_page, current_page_fields = [], is_completed = false;
    const dispatch = useDispatch();
    const { markAsFreezed } = useOutletContext();
    const client = useApolloClient();
    const params = useParams();
    let lead_id = crypto.decode(params.lead_id);
    const [allowSubmit, setAllowSubmit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isDataChanged, setIsDataChanged] = useState(false);
    const [isFileUploaded, setIsFileUploaded] = useState(false);
    const [isDocRequired, setIsDocRequired] = useState(false);
    const [vehicleAndSoftCreditData, setVehicleAndSoftCreditData] = useState({});
    const [creditAdviceReceived, setCreditAdviceReceived] = useState({});
    const [vehicleAndSoftCreditDataExisted, setVehicleAndSoftCreditDataExisted] = useState({});
    const [softApprovalData, setSoftApprovalData] = useState([]);
    const [vehicleAndSoftCreditDocs, setVehicleAndSoftCreditDocs] = useState([]);
    const [vehicleAndSoftCreditDocuments, setVehicleAndSoftCreditDocuments] = useState([]);
    const [softApprovalDocs, setSoftApprovalDocs] = useState([]);
    const [softApprovalDocList, setSoftApprovalDocsList] = useState([]);
    const [errors, setErrors] = useState({});
    const [ViewTimeLine, setViewTimeLine] = useState(false);
    const [showremarkform, setShowremarkform] = useState(false);
    const formFieldsAndDocs = VehicleDetailAndSoftCreditJson[current_page];
    let [maxTime, setMaxTime] = useState(now.setHours(currhour, currmin, 0));

    const FinancingFromMinDate = new Date().setMonth(new Date().getMonth() - 2); // Set minDate to 2 months ago
    const FinancingFromMaxDate = new Date().setMonth(new Date().getMonth() + 2); // Set maxDate to 2 months from now
    
    current_page_fields = formFieldsAndDocs.form_fields || [];
    let current_docs = formFieldsAndDocs.upload_docs || [];
    let current_doc_reuired = 0;
    const { leadDetail, remarksHistory, userInfo } = useSelector(({ lead, user }) => {
        return {
            leadDetail: lead.leadDetail,
            remarksHistory: lead.remarksHistory || [],
            userInfo: user.user_information
        };
    });

    const adp_type = leadDetail?.lead_computation_details?.title_transfer_type === "Yes" || false;
    const form_read_only = isPageReadOnly(current_page, leadDetail);

    let accessCondition = !IS_USER_ACCESS_PAGE(current_page, current_page)?.is_edit_access;
    if (!accessCondition) {
        accessCondition = CHECK_ASSIGN_USER(leadDetail?.assign_to);
    }
    let userDetail = userInfo && JSON.parse(userInfo);
    let user_id = userDetail && (userDetail.id || 0);
    const getContext = useOutletContext();
    let navigate = useNavigate();
    const documentCategoryList = (getContext && getContext.docList) || [];
    useEffect(() => {
        setIsFileUploaded(false);
        let doc_array = [], uploaded_doc = 0;
        if (["orcr_sent_for_verification"].includes(current_page)) {
            const docs_to_filter = [];
            if (leadDetail?.lead_computation_details?.title_transfer_type === "Yes" && leadDetail?.lead_computation_details?.orcr_docs_verification_done === "Yes") {
                docs_to_filter.push(138, 139);
            }
            else if (leadDetail?.lead_computation_details?.title_transfer_type === "No" && leadDetail?.lead_computation_details?.orcr_docs_verification_done === "Yes") {
                docs_to_filter.push(104, 137);
            }
            current_docs = current_docs.filter(doc => docs_to_filter.includes(doc?.doc_id));
        }
        current_docs && current_docs.map((field) => {
            if (field.required === true) current_doc_reuired++;
            documentCategoryList.map(obj => { return obj.child && obj.child.map(child => child.id === field.doc_id ? doc_array.push(child) : doc_array.push({})); });
            return current_doc_reuired;
        });
        doc_array = doc_array.filter(obj => Object.keys(obj).length !== 0);
        let lead_docs_new = [];
        doc_array.forEach((obj) => {
            let lead_doc_arr = leadDetail.leaddocs && leadDetail.leaddocs.filter(lead_doc_obj => lead_doc_obj.doc_id === obj.id);
            lead_doc_arr.forEach(element => {
                if (element !== undefined) {
                    lead_docs_new.push(element);
                }
            });
        });
       
        if (current_page === "soft_approval") {
            let softApprovalDocsArr = [];
            leadDetail?.financier?.forEach((v) => {
                doc_array.forEach((obj) => {
                    lead_docs_new = leadDetail.leaddocs && leadDetail.leaddocs.filter(lead_doc_obj => lead_doc_obj.doc_id === obj.id);
                    softApprovalDocsArr.push({ ...obj, financier_id: v.financier_id, lead_doc_count: 0 });
                });
            });
            
            softApprovalDocsArr.forEach((obj) => {
                let count = 0;
                lead_docs_new?.forEach((v) => {
                    if (v.financier_id === obj.financier_id) {
                        count++;
                    }
                });
                obj.lead_doc_count = count;
            });
              
            setSoftApprovalDocs(softApprovalDocsArr);
        }

        if (["credit_advice_received"].includes(current_page)) {
            const docsPresent = [...lead_docs_new?.map(doc => doc.doc_id)];
            handleEitherDocCondition(doc_array, docsPresent);
        }
        const updatedDocs = doc_array.map(obj => {
            let leadCatWiseDoc = lead_docs_new.filter(v => v.doc_id === obj.id);
            if (["orcr_sent_for_verification", "orcr_received"].includes(current_page)) {
                if (leadDetail?.lead_computation_details?.title_transfer_type === "Yes" && leadDetail?.lead_computation_details?.orcr_docs_verification_done === "Yes" && [104, 137, 138, 139].includes(obj?.id)) {
                    obj.is_required = ([138, 139].includes(obj?.id) && "1") || ([104, 137].includes(obj?.id) && "0");
                }
                else if (leadDetail?.lead_computation_details?.title_transfer_type === "No" && leadDetail?.lead_computation_details?.orcr_docs_verification_done === "Yes" && [104, 137, 138, 139].includes(obj?.id)) {
                    obj.is_required = ([138, 139].includes(obj?.id) && "0") || ([104, 137].includes(obj?.id) && "1");
                }
            }
            if (leadCatWiseDoc && leadCatWiseDoc.length > 0) {
                current_docs && current_docs.map((field) => {
                    if (field.doc_id === obj.id && field.required === true)
                        uploaded_doc++;
                    return uploaded_doc;
                });
                return { ...obj, "lead_doc_count": leadCatWiseDoc.length };
            } else {
                return { ...obj, "lead_doc_count": 0 };
            }
        });

        if (uploaded_doc === current_doc_reuired) setIsFileUploaded(true);
        
        setVehicleAndSoftCreditDocuments(updatedDocs);
    }, [getContext]);

    useEffect(() => {
        setVehicleAndSoftCreditDocs([]);
        const fetchData = async () => {
            getVehicleDetailAndSoftCredit(leadDetail);
        };
        fetchData();
    }, [leadDetail, props]);

    const showModalViewTimeLine = () => {
        setViewTimeLine(true);
        setShowremarkform(true);
        document.body.classList.add("overflow-hidden");
    };
    
    const hideModalViewTimeLine = () => {
        setViewTimeLine(false);
        document.body.classList.remove("overflow-hidden");
    };


    const getVehicleDetailAndSoftCredit = (data) => {
        if (current_page === "soft_approval") {
            let soft_approval_data_arr = [];
            data?.soft_approval_ci_data?.forEach((soft_app_obj) => {
                let soft_approval_data_obj = {};
                current_page_fields.forEach(obj => {
                    if (soft_app_obj && soft_app_obj.hasOwnProperty(obj.name)) {
                        soft_approval_data_obj = {
                            ...soft_approval_data_obj,
                            [obj.name]: obj.type === "date-picker" ? (soft_app_obj && soft_app_obj[obj.name] ? new Date(soft_app_obj && soft_app_obj[obj.name]) : new Date()) : soft_app_obj && soft_app_obj[obj.name]
                        };
                    }
                });
                soft_approval_data_obj.financier_id = soft_app_obj.financier_id;
                let financier_name = data.financier.filter((v) => v.financier_id === soft_app_obj.financier_id)[0].financier.financierlang.financier_name;
                soft_approval_data_obj.financier_name = financier_name;
                soft_approval_data_obj.send_to_financier = soft_app_obj.send_to_financier;
                soft_approval_data_obj.org_is_soft_approval_received = soft_approval_data_obj.is_soft_approval_received;
                soft_approval_data_obj.org_custom_soft_approval_received = soft_app_obj["custom_soft_approval_received_date"] ? new Date(soft_app_obj && soft_app_obj["custom_soft_approval_received_date"]) : "";
                soft_approval_data_arr.push(soft_approval_data_obj);
            });
            console.log("soft_approval_data_arr>>>>>", soft_approval_data_arr);
            setSoftApprovalData(soft_approval_data_arr);
        } else if (current_page === "credit_investigation_recieved") {
            let ci_data_arr = [];
            data?.soft_approval_ci_data?.filter((saci) => saci.credit_investigation !== null)?.forEach((soft_app_obj) => {
                let ci_data_obj = {};
                current_page_fields.forEach(obj => {
                    ci_data_obj[obj.name] = soft_app_obj && soft_app_obj[obj.name];
                });

                ci_data_obj.financier_id = soft_app_obj.financier_id;
                let financier_name = data.financier.filter((v) => v.financier_id === soft_app_obj.financier_id)[0].financier.financierlang.financier_name;
                ci_data_obj.financier_name = financier_name;
                ci_data_obj.send_to_financier = soft_app_obj.credit_investigation_recieved_date;
                ci_data_obj.credit_investigation_recieved_date = soft_app_obj?.credit_investigation_recieved_date;
                ci_data_obj.org_is_credit_investigation_received = soft_app_obj?.is_credit_investigation_received;

                ci_data_arr.push(ci_data_obj);
            });
            setSoftApprovalData(ci_data_arr);
        }
        else {
            let lead_detail_data = {};
            current_page_fields.forEach(obj => {
                if (data.lead_details && data.lead_details.hasOwnProperty(obj.name)) {
                    lead_detail_data = {
                        ...lead_detail_data,
                        [obj.name]: data.lead_details ? data.lead_details[obj.name] : ""
                    };
                }
                if (data.lead_status_dates && data.lead_status_dates.hasOwnProperty(obj.name)) {
                    lead_detail_data = {
                        ...lead_detail_data,
                        [obj.name]: data.lead_status_dates && data.lead_status_dates[obj.name] ? new Date(data.lead_status_dates && data.lead_status_dates[obj.name]) : ''
                    };
                }
            });
            lead_detail_data.orcr_verification_status = data?.lead_details?.orcr_verification_status;
            if (!lead_detail_data?.financing_from_date) lead_detail_data.financing_from_date = null;
            if (!lead_detail_data?.financing_till_date) lead_detail_data.financing_till_date = null;
            setVehicleAndSoftCreditDataExisted(lead_detail_data);
            setVehicleAndSoftCreditData(lead_detail_data);
        }
    };
    let required_counter = 0;

    const handleFileChange = async (event, doc_id, parent_id, max_upload, lead_doc_count, financier_id) => {
        let selectedImage = event?.target?.files?.[0]?.name || "";
        let publicUrl = '', doc_path = '';
        if (!selectedImage) {
            toast.error("Please upload an image.");
            return;
        }

        if (errors['document_required']) delete errors.document_required;
        setIsLoading(true);
        if ((max_upload - lead_doc_count) > 0) {
            const formData = new FormData();
            formData.append('upload_type', 'finance_docs');
            formData.append('lead_id', lead_id);
            formData.append('images', event.target.files[0]);

            try {
                publicUrl = await GeneralService.uploadFilesToS3(formData, { 'Content-Type': 'multipart/form-data' });
                doc_path = publicUrl && publicUrl.data && publicUrl.data.data && publicUrl.data.data.length && (publicUrl.data.data[0].file_url || '');
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
            }
            required_counter = setDocPath({ current_page, softApprovalDocs, doc_id, financier_id, required_counter, lead_doc_count, setSoftApprovalDocs, softApprovalDocList, lead_id, parent_id, doc_path, user_id, setSoftApprovalDocsList, vehicleAndSoftCreditDocs, handleEitherDocCondition, vehicleAndSoftCreditDocuments, setVehicleAndSoftCreditDocuments, leadDetail, setVehicleAndSoftCreditDocs });
        }
        
        vehicleAndSoftCreditDocuments.filter((v) => v.is_required === "1").length === required_counter && setIsFileUploaded(true);
        setIsDocRequired(false);
    };
    const handleEitherDocCondition = (arrayObj, docsPresent = []) => {
        arrayObj?.map(doc => {
            if ([96, 136].includes(doc?.id)) {
                if (doc?.id === 96 && docsPresent.includes(136)) doc.is_required = '0';
                if (doc?.id === 136 && docsPresent.includes(96)) doc.is_required = '0';
            }
            return doc;
        });
        return arrayObj;
    };
    useEffect(() => {
        if (["credit_advice_received"].includes(current_page)) {
            const docsPresent = [...vehicleAndSoftCreditDocs?.map(doc => doc.doc_id)];
            handleEitherDocCondition(vehicleAndSoftCreditDocuments, docsPresent);
        }
    }, [vehicleAndSoftCreditDocs, vehicleAndSoftCreditDocs?.length]);
    const isValidFileSubmit = useMemo(() => {
        if (["credit_advice_received"].includes(current_page)) {
            const existsMandatoryDoc = vehicleAndSoftCreditDocuments?.some(doc => [96, 136].includes(doc?.id) && doc?.lead_doc_count > 0);
            return (existsMandatoryDoc) || (!existsMandatoryDoc && vehicleAndSoftCreditDocs?.some(doc => [96, 136].includes(doc?.doc_id)));
        }
        if (["orcr_received"].includes(current_page)) {
            return vehicleAndSoftCreditDocuments?.every(doc => (doc?.is_required === "1" && doc?.lead_doc_count > 0) || (doc?.is_required === "0" && doc?.lead_doc_count >= 0));
        }
        if (["orcr_sent_for_title_transfer"].includes(current_page)) {
            return vehicleAndSoftCreditDocuments?.every(doc => (doc?.is_required === "1" && doc?.lead_doc_count > 0) || (doc?.is_required === "0" && doc?.lead_doc_count >= 0));
        }
        if (["orcr_received_after_title_transfer"].includes(current_page)) {
            return vehicleAndSoftCreditDocuments?.every(doc => (doc?.is_required === "1" && doc?.lead_doc_count > 0) || (doc?.is_required === "0" && doc?.lead_doc_count >= 0)) && leadDetail?.lead_computation_details?.title_transfer_type === 'Yes' && ![TITLE_BOX_ACTION.lead_created].includes(leadDetail?.titlebox?.transfer_status);
        }
        return true;
    }, [vehicleAndSoftCreditDocuments, vehicleAndSoftCreditDocs]);
    const isValidDateSubmit = useMemo(() => {
        if (["credit_advice_received"].includes(current_page) && current_page_fields?.length) {
            current_page_fields = current_page_fields?.map(field => {
                if (["custom_credit_advice_received_date"].includes(field?.name) && vehicleAndSoftCreditData?.pre_approval_received_date) {
                    field.required = false;
                }
                if (["pre_approval_received_date"].includes(field?.name) && vehicleAndSoftCreditData?.custom_credit_advice_received_date) {
                    field.required = false;
                }
                return field;
            });
            return (vehicleAndSoftCreditData?.custom_credit_advice_received_date || vehicleAndSoftCreditData?.pre_approval_received_date) ? true : false;
        }
        return true;
    }, [vehicleAndSoftCreditData?.custom_credit_advice_received_date, vehicleAndSoftCreditData?.pre_approval_received_date]);
    const handleInputChange = (target_name, field_type, event, financier_id = 0) => {
        if (event && ["credit_advice_received"].includes(current_page)) {
            let lead_detail_data = { ...vehicleAndSoftCreditData };
            if (errors[target_name])
                delete errors.target_name;
            lead_detail_data[target_name] = field_type === "date-picker" ? event : event.target.value;
            setVehicleAndSoftCreditData(lead_detail_data);
        }
        else if (event && current_page === "soft_approval") {
            let updatedSoftApprovalData = softApprovalData?.map((obj) => {
                let obj1 = { ...obj };
                if (obj.financier_id === financier_id) {
                    obj1[target_name] = field_type === "date-picker" ? event : event.target.value;
                }
                return obj1;
            });
            setSoftApprovalData(updatedSoftApprovalData);
        }
        else if (event && current_page === "credit_investigation_recieved") {
            let softApprovalDataTemp = softApprovalData;
            let obj = softApprovalDataTemp?.filter((sa) => sa.financier_id === financier_id)[0];
            if (obj.financier_id === financier_id) {
                obj[target_name] = field_type === "date-picker" ? event : event.target.value;
                if (field_type === "date-picker") {
                    obj['new_texarea'] = 1;
                }
            }
            setSoftApprovalData([...softApprovalData]);
        }
        else if (event && current_page !== "soft_approval") {
            let lead_detail_data = { ...vehicleAndSoftCreditData };
            if (errors[target_name])
                delete errors.target_name;
            lead_detail_data[target_name] = field_type === "date-picker" ? event : event.target.value;
            if (current_page === "contract_signed" && target_name === "financing_from_date")
                delete lead_detail_data["financing_till_date"];
            setVehicleAndSoftCreditData(lead_detail_data);
        }
        if (field_type === "date-picker") {
            if (compareDate(event)) setMaxTime(now.setHours(23, 59, 59));
            else setMaxTime(now.setHours(currhour, currmin, 0));
        }
    };

    const handleRadioChange = (target_name, e, financier_id) => {
        let lead_docs = leadDetail?.leaddocs?.filter((obj) => Number(obj.financier_id) === Number(financier_id) && obj.doc_id === 88)?.length;
        let softApprovalDataTemp = softApprovalData;
        let ci_data_arr = softApprovalDataTemp?.filter((sa) => sa.financier_id === financier_id)[0];
        if (!ci_data_arr?.org_is_credit_investigation_received || ci_data_arr?.org_is_credit_investigation_received === null) {
            ci_data_arr[target_name] = e.target.value;
            setSoftApprovalData([...softApprovalData]);
            setIsDataChanged(true);
        }
        if (target_name === "is_soft_approval_received" && e.target.value === "yes" && !lead_docs) {
            setIsDocRequired(true);
        }
        else setIsDocRequired(false);
        if (current_page === "soft_approval")
            setIsDataChanged(true);
        const softApprovalDocListReset = softApprovalDocList.filter((obj) => obj.financier_id !== financier_id);
        setSoftApprovalDocsList(softApprovalDocListReset);
        let softApprovalDocsReset = softApprovalDocs.forEach((obj) => {
            obj.lead_doc_count = leadDetail?.leaddocs?.filter((doc) => Number(doc.financier_id) === Number(obj.financier_id) && doc.doc_id === 88)?.length || softApprovalDocListReset.filter(docs => docs.financier_id === obj.financier_id)?.length || 0;
        });
        if (softApprovalDocsReset && softApprovalDocs.length) setSoftApprovalDocs(softApprovalDocsReset);
    };
    function compareDate(selectedDate) {
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        let d = new Date(selectedDate);
        d.setHours(0, 0, 0, 0);
        if (d < today) {
            return true;
        }
        return false;
    }

    const validateFormData = () => {
        let errorsObj = { ...errors };
        let hasError = false;
        if (current_page_fields.length) {
            current_page_fields.map(fields => {
                if (fields.is_required && !vehicleAndSoftCreditData[fields.name])
                    errorsObj = { ...errorsObj, [fields.name]: true };
                return fields;
            });
        } else if (vehicleAndSoftCreditDocuments.length) {
            vehicleAndSoftCreditDocuments.map(field => {
                if (field.is_required === true && field.lead_doc_count === 0) {
                    errorsObj = { ...errorsObj, document_required: true };
                }
                return field;
            });
        }
        setErrors(errorsObj);
        Object.keys(errorsObj).forEach(key => {
            if (errorsObj[key] === true) {
                hasError = true;
            }
        });
        if (is_completed) {
            setAllowSubmit(false);
        } else {
            if (hasError)
                setAllowSubmit(false);
            else
                setAllowSubmit(true);
        }
        return hasError ? false : true;
    };
    
    const saveFormDetails = async () => {
        const finalSoftApprovalArr = softApprovalData.map(({ financier_name, send_to_financier, org_is_soft_approval_received, org_custom_soft_approval_received, ...newObj }) => {
            newObj.lead_id = Number(lead_id);
            return newObj;
        });
    
        if (!validateFormData()) return;
        setIsLoading(true);
    
        let commonFields = {
            lead_id: Number(lead_id),
            tab_name: props.current_page,
            user_id: user_id
        };
    
        current_page_fields.forEach(fields => {
            commonFields[fields.name] = vehicleAndSoftCreditData[fields.name];
        });
        const { variables, mutation, redirecturl } = generateMutationAndVariables({ current_page: props.current_page, commonFields, finalSoftApprovalArr, vehicleAndSoftCreditDocs, adp_type, lead_id, user_id, params, softApprovalDocList, leadDetail, setSoftApprovalDocsList, softApprovalData });    
        try {
            await executeGraphQLMutation(mutation, variables, client);
            dispatch(getLoanDetail(lead_id, client));
            toast.success("Success");
            setIsLoading(false);
            if (redirecturl) {
                navigate(redirecturl);
            }
            setIsDataChanged(false);
        } catch (error) {
            setIsLoading(false);
            toast.error(error.toString().replace('ApolloError:', ''));
            console.error(error);
        }
        
    };

    const updatestatus = () => {
        setIsLoading(true);
        let variables = {
            updateleadstatus: { page_type: current_page, user_id: user_id, lead_id: leadDetail?.id }
        };
        executeGraphQLMutation(UPDATE_LEAD_STATUS, variables, client).then(() => {
            dispatch(getLoanDetail(leadDetail.id, client));
            setIsLoading(false);
            let redirecturl = `/lead-detail/credit-document-received/${params.lead_id}`;
            if (redirecturl !== '')
                navigate(redirecturl);
        });
    };
      
    let sectionInfo = getSectionInfo(props);
    const isLeadHistoryExists = leadDetail?.lead_status_history.some((data) => data.sub_status_id === 4);
    const financierKeyVal = useMemo(() => {
        return leadDetail?.financier?.reduce((result, data) => {
            result[data?.financier_id] = { ...data?.financier?.financierlang, ...data } || {}
            return result;
        }, {})
    }, [leadDetail?.financier])

    const propsToPass = {
        props, softApprovalData, current_page_fields, isLeadHistoryExists, form_read_only, current_page, maxTime, softApprovalDocs, markAsFreezed, allowSubmit, accessCondition, isDocRequired, isDataChanged, leadDetail, params, remarksHistory, vehicleAndSoftCreditData, vehicleAndSoftCreditDataExisted, FinancingFromMinDate, FinancingFromMaxDate, vehicleAndSoftCreditDocuments, isValidDateSubmit, isValidFileSubmit, isFileUploaded,
        financierKeyVal, creditAdviceReceived,
        user_id, setIsLoading,
        setCreditAdviceReceived,
        setAllowSubmit, handleInputChange, handleRadioChange, handleFileChange, saveFormDetails, navigate, showModalViewTimeLine, updatestatus,
    };
    
    return (<React.Fragment key={`${props.current_page}`}>
        <div className="image-form-outer">
            <div className="image-tab-panel">
                <DocumentGallery documentCategoryList={documentCategoryList} />
            </div>
            <div className="form-tab-right-panel">
                <div className="lead-detail-from-outer">
                    {["soft_approval", "credit_investigation_recieved"]?.includes(props.current_page) ?
                        <SoftApprovalCreditInvestigation {...propsToPass} /> :
                    ["credit_advice_received"]?.includes(props.current_page) ?
                        <CreditAdviceReceived {...propsToPass} />
                        :
                        <VehicleTransferCreditInvestigation {...propsToPass} />
                    }
                </div >
            </div>
            {isLoading ? <Loader /> : <></>}
            <div className="view-timeline-popup">
                <div className="view-timeline-popup">
                    <Modal show={ViewTimeLine} handleClose={hideModalViewTimeLine} >
                        <div className="modal-header">
                            <h2>Remark History</h2>
                        </div>
                        <LeadRemarkHistory showremarkform={showremarkform} markAsFreezed={markAsFreezed} accessCondition={accessCondition} sectionInfo={sectionInfo} />
                    </Modal>
                </div>
            </div>
        </div>
    </React.Fragment>
    );
};

export default VehicleDetailAndSoftCredit;

